var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.config),function(item,key){return _c('div',{key:key,attrs:{"item":item}},[_vm._v("\n    "+_vm._s(key)+"\n    "),_c('el-input',{on:{"input":_vm.change},model:{value:(_vm.temp[key]),callback:function ($$v) {_vm.$set(_vm.temp, key, $$v)},expression:"temp[key]"}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a2f6e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/card/views/supplier/SupplierConfig.vue
// module id = null
// module chunks = 